import { ElementType } from "../../../dom-tools/ElementType";
import { ScrollViewBase } from "../../../dom-ui/components/ScrollViewBase";
import { UIComponent } from "../../../dom-ui/components/UIComponent";

export class ToolBar extends UIComponent
{
  static readonly elementType = new ElementType( "composer-tool-bar" );

  constructor()
  {
    super();

    this._setElement( ToolBar.elementType.create() );
  }
}